import {params} from '../vars/params';
import {config} from '../../config';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const setResize = (): void => {
  if (!params.isSp) {
    params.bW = document.documentElement.clientWidth;
    params.bH = document.documentElement.clientHeight;
    params.isSp = params.bW < config.breakPoint;
    params.isTall = params.bW < params.bH * 0.5;
    ScrollTrigger.refresh();
  }
};
